import { api } from '@/api/client';


const ROUTING_ENDPOINTS = {
  LIST: '/merchant/v1/get-rules/',
  CREATE: '/merchant/v1/set-rules/',
  CONNECTION: '/merchant/v1/onboard-payment-gateway/',
  DELETE: (id: string) => `/merchant/v1/delete-rule/${id}/`,
  // FILTER: '/merchant/v1/settlements/',
  // STATS: '/merchant/v1/settlements-stats/',
  // DOWNLOAD: '/merchant/v1/settlements/download/',
  // DETAIL: (id: string) => `/merchant/v1/settlements/${id}/`,
} as const;

class RoutingRulesService {

  /**
   * Get paginated list of routing rules
   */
  async getRoutingRules(): Promise<any> {
    try {
      const url = `${ROUTING_ENDPOINTS.LIST}`;
      const response = await api.get<any>(url);

      return response;

    } catch (error) {
      throw this.handleError(error, 'Failed to fetch routing rules');
    }
  }

  /**
   * Create a new routing rule
   */
  async createRoutingRule(ruleData: any): Promise<any> {
    try {
      const url = `${ROUTING_ENDPOINTS.CREATE}`;
      const response = await api.post<any>(url, ruleData);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to create routing rule');
    }
  }

  /**
   * Get payment gateways list (if needed for dropdown)
   * Note: Adjust the endpoint based on your actual API
   */
  async getPaymentGateways(): Promise<any> {
    try {
      // Adjust this endpoint based on your actual API
      const response = await api.get<any>('/merchant/v1/payment-gateways/');
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch payment gateways');
    }
  }


  /**
   * Delete a routing rule
   */
  async deleteRoutingRule(ruleId: string): Promise<any> {
    try {
      const url = ROUTING_ENDPOINTS.DELETE(ruleId);
      const response = await api.delete<any>(url);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to delete routing rule');
    }
  }

  /**
   * Create a new connection to a payment gateway
   */
  async createConnection(ruleData: any): Promise<any> {
    try {
      const url = `${ROUTING_ENDPOINTS.CREATE}`;
      const response = await api.post<any>(url, ruleData);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to create routing rule');
    }
  }

  /**
 * Handle API errors
 */
  private handleError(error: unknown, defaultMessage: string): Error {
    if (error && typeof error === 'object' && 'message' in error) {
      return error as Error;
    }
    return new Error(defaultMessage);
  }
}

// Create singleton instance
export const routingRulesService = new RoutingRulesService();

// Export for testing
export { RoutingRulesService }


